export const AvatarType = {
  PictureAndName: 0,
  CommunityWork: 1,
};
